import axios from "axios";
import { tokenManager } from "utils/tokenManager";

const KPI_API_BASE = "https://usibras-web-backend.onrender.com/api";

/**
 * Fetch a worker's evaluation report.
 *
 * @param {string} evaluateeId - The worker/user ID
 * @returns {Promise<{ data: Object, message: string }>}
 */
export async function getWorkerReport(evaluateeId, fromDate, toDate) {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const params = { evaluatee_id: evaluateeId };
  if (fromDate) params.from_date = fromDate;
  if (toDate) params.to_date = toDate;
  const response = await axios.get(`${KPI_API_BASE}/kpi-reports/worker`, { headers, params });
  return response.data;
}

/**
 * Fetch a sector's evaluation report.
 *
 * @param {string} sectorId - The sector ID
 * @returns {Promise<{ data: Object, message: string }>}
 */
export async function getSectorReport(sectorId) {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const params = { sector_id: sectorId };
  if (arguments.length > 1) {
    const fromDate = arguments[1];
    const toDate = arguments[2];
    if (fromDate) params.from_date = fromDate;
    if (toDate) params.to_date = toDate;
  }
  const response = await axios.get(`${KPI_API_BASE}/kpi-reports/sector`, { headers, params });
  return response.data;
}
